import React, { useEffect } from 'react';
import AsyncComponent from '../../components/async-component';
import PageWrap from '../../components/page-wrap';
import PageTitle from '../../components/page-title';
import PageContent from '../../components/page-content';
import { Row, Col, Spinner } from 'reactstrap';
import NavigationTopRight from '../../components/navigation-top-right';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { paymentLinkDetails } from '../../actions/payment-links';
import _ from 'lodash';
import { updatePaginatedData } from '../../utils';
import { GET_MEMBERSHIP_DETAIL } from '../../gqls';
import { setLandingPromotion } from '../../actions/landing-promotion';

const MembershipDiscussionDetail = () => {
  const currentUser = useSelector(state => state.currentUser);
  const um = useSelector(state => state.updatePaymentLinks);
  const dispatch = useDispatch();

  const { id } = useParams();
  const { loading, error, data, fetchMore } = useQuery(GET_MEMBERSHIP_DETAIL, {
    variables: { id }
  });

  const pl = _.get(data, 'getPaymentLink');

  useEffect(() => {
    if (pl) {
      dispatch(paymentLinkDetails(pl));
      dispatch(setLandingPromotion(null));
    }
  }, [pl, dispatch]);

  const updateData = () => {
    fetchMore({
      variables: { id },
      updateQuery: (previousResult, { fetchMoreResult }) =>
        updatePaginatedData('getPaymentLink', previousResult, fetchMoreResult),
      notifyOnNetworkStatusChange: true
    });
  };

  useEffect(() => {
    updateData();
  }, [um]);

  if (loading)
    return (
      <div className="fullscreen-div d-flex justify-content-center align-items-center height-100vh">
        <Spinner animation="border" role="status" />
      </div>
    );

  if (error)
    return (
      <div className="fullscreen-div d-flex justify-content-center align-items-center height-100vh">
        {`Error! ${error.message}`}
      </div>
    );

  if (data && data.getPaymentLinkPage && data.getPaymentLinkPage.items.length === 0) {
    window.location.href = process.env.REACT_APP_BASE_URL;
  }

  return (
    <PageWrap>
      <PageTitle
        className="d-none d-sm-block"
        breadcrumbs={{
          '/': currentUser ? currentUser.name : ' ',
          '/memberships': 'Membership & SaaS',
          [`/membership-detail/${pl?.id}?tab=discussion`]: pl?.name || ' ',
          '#': 'Detail Diskusi'
        }}
      >
        <Row className="mb-0">
          <Col md="4">
            <h1>Diskusi: {pl?.name}</h1>
          </Col>
          <Col md="8" className="text-right">
            <NavigationTopRight />
          </Col>
        </Row>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default MembershipDiscussionDetail;
